import { PropostalStatus } from "../types/propostals";

export interface ChatsInfo{
   client_id:number,
   createdAt:string,
   current_state:string,
   call_source:string,
}

export interface NewClientsInfo{
    numberNewClients:number,
    numberNewSavedClients:number,
    totalClients:number,
    totalSavedClients:number,
}
export interface WANumberResult{
    sender_number:string,
    totalValue:number,
    numberOfPropostals:number,
}

export interface PropostalResultByDDD{
    DDD:string,
    totalValue:number,
    numberOfPropostals:number,
}

export interface ConsultInfo{
    login:string,
    provider:string,
    createdAt:string,
}
export interface PropostalInfo{
    client_withdrawn_value:number,
    createdAt:string,
    sender_number:string,
    clientDDD:string,
    propostal_id:string,
    call_source:string,
    /** Canal: whatsapp/instagram/evolution/telegram/autofgts. NULL nas antigas. */
    chat_source?:string|null,
    status:PropostalStatus,
    table_fee_id:string,
}

export enum TableFeeId{
    cometa='61c9fb2f-c902-4992-b8f5-b0ee368c45b0',
    normal='cb563029-ba93-4b53-8d53-4ac145087212',
    turbo='8beaa78b-b7ba-4f48-853e-de9f322be42f',
    acelera='f6d779ed-52bf-42f2-9dbc-3125fe6491ba',
    podium='755a9628-9438-4573-a44d-8bbb00e2d105',
    pitstop='cd67cb02-c49d-457e-bfa9-a99316eb9dfe'
}

export function getTableNameByID(id:string){
    const keys=Object.keys(TableFeeId);
    const values=Object.values(TableFeeId);
    
    for(let i=0;i<values.length;i++){
         if(values[i]==id)
             return keys[i];
    }
    return "Outras";
 }